import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LazyLoadImage from '../images/LazyLoadImage';
import FullHeightSwipeableDrawer from '../drawer/FullHeightSwipeableDrawer';

const SummaryInfoDrawer = ({ open, onClose, infoTitle, info }) => (
  <FullHeightSwipeableDrawer
    open={open}
    onClose={onClose}
    title={infoTitle}
  >
    <Box sx={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%',
      maxHeight: 650,
      mb: 2,
    }}
    >
      {info && info.map((item) => (
        <Box key={item.label}>
          <Typography
            variant="medium_1"
            sx={{ fontWeight: 700 }}
            color="text.highlight"
          >
            {item.label}
          </Typography>
          <Typography component="span" variant="small_3" sx={{ whiteSpace: 'pre-line', display: 'block' }}>
            {item.value}
          </Typography>
          {item.equation && (
          <Box sx={{ mt: 1 }}>
            <LazyLoadImage
              src={item.equation}
              alt={item.alt}
              width={item.width}
              height={item.height}
            />
          </Box>
          )}
        </Box>
      ))}
    </Box>
  </FullHeightSwipeableDrawer>
);

SummaryInfoDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  infoTitle: PropTypes.string,
  info: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    equation: PropTypes.string,
    alt: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  })),
};

SummaryInfoDrawer.defaultProps = {
  infoTitle: '',
  info: [],
};

export default SummaryInfoDrawer;
